import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-06446561"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "statusContainer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "iconTitle" }
const _hoisted_4 = { class: "ctaLink rte" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = { class: "inner" }
const _hoisted_7 = { class: "printOnly" }
const _hoisted_8 = { class: "printHeader" }
const _hoisted_9 = { class: "date" }
const _hoisted_10 = { class: "col1" }
const _hoisted_11 = { class: "desktop h2" }
const _hoisted_12 = {
  key: 1,
  class: "mobile editInput"
}
const _hoisted_13 = { class: "mobile fareInfo" }
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 2,
  class: "content"
}
const _hoisted_16 = {
  key: 0,
  class: "downloadTimetables mobile"
}
const _hoisted_17 = { class: "col2" }
const _hoisted_18 = {
  key: 1,
  class: "routeInformation"
}
const _hoisted_19 = {
  key: 2,
  class: "downloadTimetables desktop"
}
const _hoisted_20 = { class: "printOnly" }

import {
  PortList,
  TimetableSearch,
  EditTimetableInput,
  BuyTicketBanner,
  Icon,
  RouteSearchMap,
  TimetableRouteInfo,
  BuyTicketSticky,
  DownloadTimetableBlock,
  TimetableResultView,
  LatLng,
} from '@components';
import {
  useRoutesStore,
  useOfflineTimetableStore,
  useTimetableStore,
} from '@components/store';
import {
  OfflineTimetablesResult,
  OfflineTimetableType,
} from '@components/apiTypes';
import {
  format, isToday, isValid, parseISO,
} from 'date-fns';
import {
  formatInTimeZone,
} from 'date-fns-tz';
import {
  onMounted, onUnmounted, ref, watch, watchEffect,
} from 'vue';
import { RouteInformation, Sailings } from '@components/types/api';
import { utcDate } from '@components/helpers';
import { useRouter } from 'vue-router';
import router from '@/router';
import { ticketingUrl, routeInformationUrl, timezone } from '../../envVariables';

const smallDesktopWidth = 1050;

export default /*#__PURE__*/_defineComponent({
  __name: 'TimetableSearchResult',
  props: {
    from: {},
    to: {},
    departureDate: {}
  },
  setup(__props: any) {

const props = __props;

const routeStore = useRoutesStore();
const offlineTimetableStore = useOfflineTimetableStore();
const timetableStore = useTimetableStore();

const vueRouter = useRouter();

const downloadTimetableItems = ref<Array<OfflineTimetablesResult> | undefined>(offlineTimetableStore
  .getOfflineTimetables);
const reinitDatepickerCarousel = ref(false);

const routeInformation = ref<RouteInformation|undefined>(routeStore.firstRoutesByPorts);
const routeCode = ref<string>(routeInformation.value?.routeCode ?? '');
const routeMapData = ref(routeStore.getMapRoutesByPortName);
const portsMapData = ref(routeStore.getMapPortsByPortName);
const centreMapData = ref<LatLng>();

const sailingResults = ref<Array<Sailings>>();

const isLoading = ref<boolean>(false);

const viewState = ref({
  search: {
    from: decodeURI(props.from),
    to: decodeURI(props.to),
    fromDate: isValid(parseISO(props.departureDate))
      ? props.departureDate : utcDate(new Date()).toISOString(),
  },
});

const windowWidth = ref(window.innerWidth);
const showTimetableInput = ref(windowWidth.value > smallDesktopWidth);

centreMapData.value = { lat: 55.609867, lng: -4.958157 };

const routeToNewDate = (
  fromInput: string,
  toInput: string,
  newDate: string,
) => {
  router.push({
    name: 'timetableResult',
    params: {
      from: encodeURI(fromInput),
      to: encodeURI(toInput),
      departureDate: formatInTimeZone(parseISO(newDate), timezone, 'yyyy-MM-dd'),
    },
  });
};

const updateSearchValues = async (
  fromInput: string,
  toInput: string,
  newDate: string,
  reinitSwiper = false,
) => {
  if (!isValid(parseISO(newDate))) {
    return;
  }

  const { from, to } = viewState.value.search;

  if (from !== fromInput || to !== toInput) {
    await routeStore.requestRouteByPorts(fromInput, toInput);
    await offlineTimetableStore.requestOfflineTimetables(fromInput, toInput);

    viewState.value.search = {
      ...viewState.value.search,
      from: fromInput ?? props.from,
      to: toInput ?? props.to,
    };
  }

  viewState.value.search.fromDate = newDate;

  reinitDatepickerCarousel.value = reinitSwiper;
  if (windowWidth.value < smallDesktopWidth) showTimetableInput.value = false;

  await timetableStore.getSearchResults(viewState.value.search);
};

const printDocument = () => window.print();

const getTimetableBlockIcon = (timetableType) => {
  switch (timetableType) {
    case OfflineTimetableType.Summer:
      return 'summerTimetable';
    case OfflineTimetableType.Tidal:
      return 'tidalTimetable';
    default:
      return 'winterTimetable';
  }
};

const routeToRouteItem = () => {
  vueRouter.push({ name: 'serviceStatusItem', params: { routeCode: routeCode.value } });
};

watchEffect(() => {
  isLoading.value = routeStore.isLoading;
});

watchEffect(() => {
  routeInformation.value = routeStore.firstRoutesByPorts;
  routeCode.value = routeInformation.value?.routeCode ?? '';
  routeMapData.value = routeStore.getMapRoutesByPortName;
  portsMapData.value = routeStore.getMapPortsByPortName;
});

watchEffect(() => {
  if (offlineTimetableStore.getOfflineTimetables) {
    downloadTimetableItems.value = offlineTimetableStore.getOfflineTimetables;
  }
});

watch(() => router.currentRoute.value, (watchedRoute) => {
  if (!isValid(parseISO(watchedRoute.params.departureDate.toString()))) {
    return;
  }
  if (watchedRoute.params.from && watchedRoute.params.to && watchedRoute.params.departureDate) {
    updateSearchValues(
      decodeURI(watchedRoute.params.from.toString()) ?? props.from,
      decodeURI(watchedRoute.params.to.toString()) ?? props.to,
      parseISO(`${watchedRoute.params.departureDate.toString()}Z`).toISOString(),
      true,
    );
  }
});

onMounted(async () => {
  document.querySelector('html')?.classList.add('removeOverflow');
  document.querySelector('body')?.classList.add('removeOverflow');

  window.addEventListener('resize', () => {
    if (window.innerWidth < smallDesktopWidth && windowWidth.value !== window.innerWidth) {
      showTimetableInput.value = false;
    } else {
      showTimetableInput.value = true;
    }
    windowWidth.value = window.innerWidth;
  });

  await timetableStore.getSearchResults(viewState.value.search);
  await routeStore.requestRouteByPorts(viewState.value.search.from, viewState.value.search.to);
  await offlineTimetableStore.requestOfflineTimetables(
    viewState.value.search.from,
    viewState.value.search.to,
  );
});

onUnmounted(() => {
  document.querySelector('html')?.classList.remove('removeOverflow');
  document.querySelector('body')?.classList.remove('removeOverflow');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Icon), { "icon-name": "boat" }),
          _createElementVNode("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.$t('Route status banner text')) + " ", 1),
            _createElementVNode("button", {
              class: "routeItemBtn",
              onClick: routeToRouteItem
            }, _toDisplayString(_ctx.$t('Route status banner link text')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["timetableSearchResults", { 'searchError' : _unref(timetableStore).isServerError }])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_unref(Icon), { "icon-name": "calmacLogo" }),
              _createElementVNode("h1", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('Calmac name')) + " ", 1),
                _createElementVNode("small", null, _toDisplayString(_ctx.$t('Calmac description')), 1)
              ])
            ]),
            _createVNode(_unref(PortList), {
              ports: [{name: viewState.value.search.from}, {name: viewState.value.search.to}]
            }, null, 8, ["ports"]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(Icon), { "icon-name": "calendar" }),
              _createElementVNode("span", null, _toDisplayString(_unref(isToday)(new Date(viewState.value.search.fromDate))
                ? `Today: ${_unref(format)(new Date(viewState.value.search.fromDate), 'EEEE, d LLLL y')}`
                : _unref(format)(new Date(viewState.value.search.fromDate), 'EEEE, d LLLL y')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.$t('Timetable Search')), 1),
            (showTimetableInput.value)
              ? (_openBlock(), _createBlock(_unref(TimetableSearch), {
                  key: 0,
                  "button-text": _ctx.$t('Search timetable'),
                  from: decodeURI(_ctx.from),
                  to: decodeURI(_ctx.to),
                  "initial-date": _ctx.departureDate,
                  onTimetableSearchClick: _cache[0] || (_cache[0] = (
              fromInput,
              toInput,
              newDate
            ) =>
              routeToNewDate(fromInput, toInput, newDate))
                }, null, 8, ["button-text", "from", "to", "initial-date"]))
              : _createCommentVNode("", true),
            (!showTimetableInput.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_unref(EditTimetableInput), {
                    ports: [{name: viewState.value.search.from}, {name: viewState.value.search.to}],
                    "toggle-input": () => showTimetableInput.value = true
                  }, null, 8, ["ports", "toggle-input"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("a", {
                class: "ctaLink",
                href: `${_unref(routeInformationUrl)}/${routeInformation.value?.routeCode}`
              }, [
                _createVNode(_unref(Icon), { "icon-name": "info" }),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Route and fare information')), 1)
              ], 8, _hoisted_14)
            ]),
            (!_unref(timetableStore).isServerError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_unref(TimetableResultView), {
                    from: viewState.value.search.from,
                    to: viewState.value.search.to,
                    "from-date": viewState.value.search.fromDate,
                    "reinit-datepicker-carousel": reinitDatepickerCarousel.value,
                    "is-web-view": true,
                    onToggleSwiper: _cache[1] || (_cache[1] = (isInit) => reinitDatepickerCarousel.value = isInit),
                    onUpdateSearchResults: _cache[2] || (_cache[2] = (newDate) => routeToNewDate(
                viewState.value.search.from,
                viewState.value.search.to,
                newDate
              )),
                    onGetSailingResults: _cache[3] || (_cache[3] = (sailings) => sailingResults.value = sailings)
                  }, null, 8, ["from", "to", "from-date", "reinit-datepicker-carousel"]),
                  (downloadTimetableItems.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(downloadTimetableItems.value, (timetable, index) => {
                          return (_openBlock(), _createBlock(_unref(DownloadTimetableBlock), {
                            key: index,
                            title: timetable.title,
                            "icon-name": getTimetableBlockIcon(timetable.timetableType),
                            ports: [{name: _ctx.from}, {name: _ctx.to}],
                            text: timetable.releaseDetail,
                            "download-link": timetable.pdfUrl
                          }, null, 8, ["title", "icon-name", "ports", "text", "download-link"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(BuyTicketBanner), {
                    "image-src": require('../../../Images/buyButtonBanner.png'),
                    "image-alt": _ctx.$t('Buy ticket image alt'),
                    "link-text": _ctx.$t('Buy tickets'),
                    title: _ctx.$t('Buy your tickets online'),
                    link: _unref(ticketingUrl)
                  }, null, 8, ["image-src", "image-alt", "link-text", "title", "link"]),
                  (sailingResults.value && sailingResults.value.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "print",
                        onClick: printDocument
                      }, [
                        _createVNode(_unref(Icon), { "icon-name": "print" }),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Print timetable')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(BuyTicketSticky), {
                    text: _ctx.$t('Buy your tickets online'),
                    "link-text": ('Buy tickets'),
                    link: _unref(ticketingUrl)
                  }, null, 8, ["text", "link"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            (routeMapData.value && portsMapData.value && centreMapData.value)
              ? (_openBlock(), _createBlock(_unref(RouteSearchMap), {
                  key: 0,
                  center: centreMapData.value,
                  ports: portsMapData.value,
                  routes: routeMapData.value,
                  "is-status-map": false
                }, null, 8, ["center", "ports", "routes"]))
              : _createCommentVNode("", true),
            (routeInformation.value && routeInformation.value.routeInformation)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("h3", null, _toDisplayString(_ctx.$t('Route information')), 1),
                  _createVNode(_unref(TimetableRouteInfo), {
                    "route-info": routeInformation.value.routeInformation,
                    "show-more-info-link": true,
                    "more-info-link-text": _ctx.$t('More information'),
                    "more-info-link": `${_unref(routeInformationUrl)}/${routeInformation.value?.routeCode}`,
                    "is-loading": isLoading.value
                  }, null, 8, ["route-info", "more-info-link-text", "more-info-link", "is-loading"])
                ]))
              : _createCommentVNode("", true),
            (downloadTimetableItems.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(downloadTimetableItems.value, (timetable, index) => {
                    return (_openBlock(), _createBlock(_unref(DownloadTimetableBlock), {
                      key: index,
                      title: timetable.title,
                      "icon-name": getTimetableBlockIcon(timetable.timetableType),
                      ports: [{name: _ctx.from}, {name: _ctx.to}],
                      text: timetable.releaseDetail,
                      "download-link": timetable.pdfUrl
                    }, null, 8, ["title", "icon-name", "ports", "text", "download-link"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("footer", _hoisted_20, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('Copyright text')), 1)
        ])
      ])
    ], 2)
  ], 64))
}
}

})